<template>
  <div class="layout outer-layout notification-send-form">
    <div
      v-if="!errorPage"
      class="front-plugin">
      <b-col
        md="10"
        offset-md="1">
        <div
          v-if="hasTemplateMessages && subscriberSelected"
          class="settings-form my-4">
          <b-col
            md="12"
            lg="7"
            class="px-0 float-left">
            <b-form-group>
              <label
                class="col-form-label pt-0">
                Contact
              </label>
              <div class="search-filter">
                <b-input
                  :value="subscriberData"
                  required
                  disabled
                  type="text"
                  autocomplete="off"
                  placeholder="No Contact"/>
              </div>
              <input
                v-model="subscriber.id"
                v-validate="'required'"
                name="contact_id"
                data-vv-as="Contact"
                type="hidden">
              <span
                v-if="errors.has('contact_id')"
                class="validation-error">{{ errors.first('contact_id') }}</span>
            </b-form-group>
            <b-form-group>
              <label class="col-form-label pt-0">
                Template
              </label>
              <b-select
                v-model="selectedTemplateKeyword"
                :options="templateKeywords"
                name="template"
                placeholder="Select Template"/>
            </b-form-group>
            <b-form-group>
              <label
                class="col-form-label pt-0">
                Language
              </label>
              <b-select
                v-model="selectedTemplateLanguage"
                placeholder="Select Template Language">
                <option
                  v-for="language in languageList"
                  :key="language"
                  :value="language"
                >{{ getLanguageName(language) }}</option>
              </b-select>
            </b-form-group>
            <b-form-group>
              <label
                class="col-form-label pt-0">
                Message
              </label>
              <div
                :class="{'text-arabic': selectedTemplateLanguage === 'ar'}"
                class="textarea-emit form-control"
                disabled>
                <MessageContent
                  :content="selectedTemplate.text || ''"/>
              </div>
            </b-form-group>
            <b-form-group
              v-for="tag in selectedTemplate.tags"
              :key="tag">
              <label
                class="col-form-label pt-0 text-lowercase">
                {{ tag }}
              </label>
              <b-input
                v-model="tagsToSend[tag]"
                v-validate="'required'"
                :name="tag"
                rows="3"/>
              <span
                v-if="errors.has(tag)"
                class="validation-error">{{ errors.first(tag) }}</span>
            </b-form-group>
            <div class="clearfix"/>
            <div
              v-if="showSuccessMessage"
              class="success-info">
              Notification has been successfully sent.
            </div>
            <div
              v-if="errorMessage"
              class="error-message">
              {{ errorMessage }}
            </div>
            <b-button
              :class="{loading: saving}"
              :disabled="saving"
              class="btn-round btn-save mt-3 mb-5"
              @click="submitMessage">
              <span v-if="!saving">Send</span>
              <div class="loader"><div class="loading-circle"/></div>
            </b-button>
          </b-col>
          <b-col
            md="12"
            lg="5"
            class="px-0 float-left">
            <div class="phone-mockup">
              <div class="phone-display scroll-area">
                <div class="message-container">
                  <div class="inbound">
                    <p :class="{'text-arabic': selectedTemplateLanguage === 'ar'}">
                      <MessageContent
                        :content="message"
                        :detect-urls="true"/>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
          <div class="clearfix"/>
        </div>
        <div
          v-if="templateMessagesLoaded && !templateKeywords.length"
          class="content-unavailable">
          <img src="~@/assets/img/whatsapp-splash.svg">
          <h4>You haven’t created any template messages.</h4>
          <p>Create template messages in order to send notifications.</p>
        </div>
        <div
          v-else-if="!conversationSelected"
          class="content-unavailable">
          <img
            class="small"
            src="~@/assets/img/banned-sign.svg">
          <p>No conversation selected.</p>
        </div>
        <div
          v-else-if="!subscriberSelected"
          class="content-unavailable">
          <img
            class="small"
            src="~@/assets/img/banned-sign.svg">
          <p>This contact is not subscribed to notifications.</p>
        </div>
        <div class="clearfix"/>
      </b-col>
    </div>
    <div
      v-else
      class="content-unavailable">
      <img
        class="small"
        src="~@/assets/img/banned-sign.svg">
      <p>Plugin authorization failed.</p>
    </div>
    <div
      id="loader"
      class="page-loader">
      <div class="loading-circle"/>
    </div>
  </div>
</template>

<script>
import {
  forEach, map, find, isEmpty,
} from 'lodash';
import crypto from 'crypto';
import setValidationErrors from '@/helpers/validationErrors';
import getLanguageName from '@/helpers/getLanguageName';
import MessageContent from '@/components/common/MessageContent';
import Axios from 'axios';

export default {
  name: 'App',
  components: {
    MessageContent,
  },
  data() {
    return {
      // frontConversationData: {},
      subscriber: {},
      merchantId: '',
      selectedTemplateKeyword: '',
      templateMessageList: {},
      selectedTemplateSet: [],
      languageList: [],
      selectedTemplate: {},
      selectedTemplateLanguage: '',
      tagsToSend: {},
      validationErrors: {},
      saving: false,
      templateMessagesLoaded: false,
      templateMessageSent: false,
      conversationSelected: false,
      showSuccessMessage: false,
      errorMessage: '',
      errorPage: false,
      axiosClient: Axios.create({ baseURL: `${this.$env.MIX_API_URL}/integrations/front/` }),
      axiosOptions: {
        headers: {
          Accept: 'application/json, text/plain, text/html, */*',
          'Content-Type': 'application/json',
        },
      },
    };
  },
  computed: {
    hasTemplateMessages() {
      return this.templateMessagesLoaded && this.templateKeywords.length;
    },
    subscriberSelected() {
      return !isEmpty(this.subscriber);
    },
    templateKeywords() {
      return Object.keys(this.templateMessageList);
    },
    message() {
      let message = this.selectedTemplate.text || '';
      forEach(this.tagsToSend, (tagValue, keyword) => {
        message = message.replace(new RegExp(`{{${keyword}}}`, 'g'), tagValue);
      });

      return message;
    },
    subscriberData() {
      return this.subscriber.phone ? `${this.subscriber.name || ''} (${this.subscriber.phone})` : '';
    },
  },
  watch: {
    templateMessagesLoaded(loaded) {
      if (loaded) {
        document.getElementById('loader').remove();
        if (this.templateKeywords.length) {
          this.selectedTemplateKeyword = this.templateKeywords[0];
        }
      }
    },
    selectedTemplateKeyword(keyword) {
      this.selectedTemplateSet = this.templateMessageList[keyword];
    },
    selectedTemplateSet(templateSet) {
      this.languageList = map(templateSet, 'language');
      this.selectedTemplate = templateSet[0];
      this.selectedTemplateLanguage = this.selectedTemplate.language;
    },
    selectedTemplateLanguage(language) {
      this.selectedTemplate = find(this.selectedTemplateSet, template => template.language === language);
    },
    templateMessageSent(messageSid) {
      if (messageSid) {
        this.saving = false;
        this.showSuccessMessage = true;

        setTimeout(() => {
          this.showSuccessMessage = false;
          this.hide();
        }, 2000);
      }
    },
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const authSecret = urlParams.get('auth_secret');
    const appKey = urlParams.get('app_key');
    this.merchantId = urlParams.get('m_id');

    if (!authSecret || !appKey || !this.merchantId) {
      this.errorPage = true;
    } else {
      this.axiosOptions.headers['X-Front-Plugin-Auth'] = this.getEncryptedApiKey(appKey, authSecret);

      window.Front.on('conversation', (data) => {
        this.getContact(data.contact.handle);
      });

      window.Front.on('no_conversation', () => {
        this.subscriber = {};
        this.conversationSelected = false;
      });

      this.api('GET', `/merchants/${this.merchantId}/template-messages`)
        .then((response) => {
          if (response.status === 200) {
            this.templateMessagesLoaded = true;
            this.templateMessageList = response.data;
          }
        });
    }
  },
  methods: {
    getLanguageName,
    setTemplate(template, tags) {
      this.selectedTemplateKeyword = template.keyword;
      this.$nextTick(() => {
        this.selectedTemplateLanguage = template.language;

        if (tags) {
          this.selectedTemplate.tags.forEach((tag) => {
            this.$set(this.tagsToSend, tag, tags[tag] || '');
          });
        }
      });
    },
    submitMessage() {
      this.validationErrors = {};
      this.errorMessage = '';

      this.$validator.validate().then((valid) => {
        if (valid) {
          this.saving = true;
          const data = {
            keyword: this.selectedTemplateKeyword,
            language: this.selectedTemplateLanguage,
            tags: this.tagsToSend,
          };

          this.api('POST', `/merchants/${this.merchantId}/subscribers/${this.subscriber.id}/send-notification`, data)
            .then((response) => {
              if (response.status === 200) {
                this.templateMessageSent = response.data.message_sid;
              }
            });
        }
      });
    },
    getContact(searchQuery) {
      const data = {
        limit: 1,
        page: 1,
        search_query: searchQuery,
      };

      this.api('GET', `/merchants/${this.merchantId}/subscribers`, data)
        .then((response) => {
          if (response.status === 200) {
            const subscribers = response.data.data;
            this.subscriber = subscribers.length ? subscribers[0] : {};
            this.conversationSelected = true;
          }
        });
    },
    setApiError(error) {
      this.saving = false;
      if (error.status === 403) {
        document.getElementById('loader').remove();
        this.errorPage = true;
      } else if (error.status === 422) {
        this.validationErrors = setValidationErrors(error.data.errors);
      } else {
        this.errorMessage = error.data.message;
      }
    },
    getEncryptedApiKey(appKey, authSecret) {
      return crypto.createHmac('sha1', appKey).update(authSecret).digest('base64');
    },
    api(method, url, data) {
      let response = {};
      url = url.trim('/');

      switch (method) {
        case 'GET':
          this.axiosOptions.params = data;
          response = this.axiosClient.get(url, this.axiosOptions);
          break;
        case 'POST':
          response = this.axiosClient.post(url, data, this.axiosOptions);
          break;
        // case 'PUT':
        //   response = this.axiosClient.put(url, data, this.axiosOptions);
        //   break;
        // case 'DELETE':
        //   this.axiosOptions.params = data;
        //   response = this.axiosClient.delete(url, this.axiosOptions);
        //   break;
        default:
          return null;
      }

      response.catch((error) => {
        if (!error.response || !error.response.data) {
          throw Error(error);
        } else {
          this.setApiError(error.response);
        }
      });

      return response;
    },
  },
};
</script>
